// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qo-0";